import React, { useEffect, useRef, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Scrollspy from 'react-scrollspy';
import _debounce from 'lodash/debounce';
import cx from 'classnames';
import Slider from 'react-slick';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import _findIndex from 'lodash/findIndex';

const useStyles = makeStyles(theme => ({
  categoryTabsContainer: {
    zIndex: 2,
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    margin: '0 -20px',
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      margin: 'initial',
    },
  },
  categoryTabsWrapper: {
    display: 'flex',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    width: 'calc(100vw - 40px)',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  categoryTab: {
    padding: '15px 12px 12px 12px',
    textAlign: 'center',
    '&.is-current': {
      borderBottom: '3px solid #076BD1',
    },
    [theme.breakpoints.up('sm')]: {
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  categoryTabLabel: {
    color: '#31415E',
    whiteSpace: 'nowrap',
  },
  leftArrow: {
    position: 'absolute',
    left: 8,
    top: 18,
    zIndex: 10,
    color: '#31415E',
  },
  rightArrow: {
    position: 'absolute',
    right: 15,
    top: 12,
    zIndex: 10,
    transform: 'rotate(180deg)',
    color: '#31415E',
  },
  '@global': {
    '.slick-slider': {
      paddingLeft: 40,
      paddingRight: 40,
      height: 48,
    },
    '.slick-next:before': {
      display: 'none',
    },
    '.slick-prev:before': {
      display: 'none',
    },
    '.slick-prev:hover, .slick-prev:focus, .slick-next:hover, .slick-next:focus': {
      color: 'inherit',
      backgroundColor: 'transparent',
    },
    '.slick-disabled': {
      display: 'none',
    },
  },
}));

const CategoryTabs = ({ categories = [], setCurrentCategorySlug, setKeyword }) => {
  const classes = useStyles();
  const sliderRef = useRef();
  const [currentSlug, setCurrentSlug] = useState('');
  const [hasInitScrollSpy, setHasInitScrollSpy] = useState(false);

  const categoriesItems = categories.map(({ slug }) => slug);

  useEffect(() => {
    setTimeout(() => {
      setHasInitScrollSpy(true);
    }, 1000);
  }, []);

  const onUpdate = _debounce(e => {
    if (e && e.id) {
      const index = _findIndex(categories, { slug: e.id });
      sliderRef.current.slickGoTo(index);
      setCurrentSlug(e.id);
      setCurrentCategorySlug(e.id);
      history.pushState(null, null, `#${e.id}`);
    }
  });

  function NextArrow(props) {
    const { className, onClick } = props;
    return (
      <IconButton
        aria-label="right"
        onClick={onClick}
        className={[className, classes.rightArrow].join(' ')}
      >
        <ArrowBackIcon />
      </IconButton>
    );
  }

  function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <IconButton
        aria-label="left"
        onClick={onClick}
        className={[className, classes.leftArrow].join(' ')}
      >
        <ArrowBackIcon onClick={onClick} className={[className, classes.leftArrow].join(' ')} />
      </IconButton>
    );
  }
  const settings = {
    dots: false,
    speed: 500,
    autoplay: false,
    infinite: false,
    slidesToShow: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
  };

  return (
    <div className={classes.categoryTabsContainer}>
      {hasInitScrollSpy ? (
        <Scrollspy
          componentTag="div"
          items={categoriesItems}
          className={classes.categoryTabsWrapper}
          offset={-30}
          onUpdate={onUpdate}
        ></Scrollspy>
      ) : null}
      <Slider ref={sliderRef} {...settings}>
        {categories.length > 0
          ? categories.map(({ label, slug = '', products = [] }, i) =>
              products.length > 0 ? (
                <a
                  href={`#${slug}`}
                  key={i}
                  onClick={() => {
                    setKeyword('');
                    setCurrentCategorySlug(slug);
                    setCurrentSlug(slug);
                    window.history.pushState(null, null, `${window.location.pathname}#${slug}`);
                  }}
                  className={cx(classes.categoryTab, { 'is-current': currentSlug === slug })}
                >
                  <span className={classes.categoryTabLabel}>{label}</span>
                </a>
              ) : null
            )
          : null}
      </Slider>
    </div>
  );
};

export default CategoryTabs;
